export class GQLException extends Error {
    constructor(...message: string[]) {
        super(message.join(', '));

        this.name = 'GQLError';
        this.stack = new Error().stack;
    }
}
